module.exports = __webpack_public_path__ + "img/creative-commons-nc-jp.96a0dd49.svg";